/**
 * Whether the user is currently looking at this tab, in which case anything
 * happening on screen has already been seen.
 *
 * @returns True when the tab is both visible and focused.
 */
export function isTabInForeground(): boolean {
	return document.visibilityState === 'visible' && document.hasFocus();
}
